export const environment = {
  production: false,
  envType: 'DEVELOPMENT',
  isFullOnline: true,
  caisseApiUrl: 'https://devgestion.quiditmiam.fr/api',
  title: 'Caisse Collective - Développement',
  buildDate: "2026-10-07T08:21:45",
  lastPipeline: "6720",
  version: "0.0.0",
  sentryDsn: '',
};
